import { QUERY_KEY } from 'constants/globalConstants'
import ApiService from 'apiService'
import { useQuery } from 'react-query'

const useNode = (id) => {
    return useQuery([QUERY_KEY.GET_NODE, id], ()=>ApiService.getNode(id))
}

export default useNode